import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm, useFieldArray, set } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { checkDpSuccess, getFormErrorMessage } from "../../utility/service/tool-service";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import {
  queryCompaniesInfo,
  updateCompaniesInfo,
  B1020103Before,
  queryCompanyTagList,
  B1020107Before,
  updateCompanyTagList,
} from "../../utility/service/company-service";
import { queryIndustryList, queryLocaleList } from "../../utility/service/register-service";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { addFormValidator } from "../../utility/validate/formValidator";
import { MaskedFormInput } from "../../components/MaskedFormInput";
import { updateAuditEyesEvent } from "../../utility/service/audilog-service";
import { useFuncId } from "../../router/menuRouterMapper";
import { useEditableFlag } from '../../hooks/useEditableFlag';
import { FormTextarea } from "../../components/FormTextarea";
import { AcctContext } from "../../utility/useReduce/userNameReduce";
import { getCBAMSubItemsByItemNo } from "../../utility/service/companyOffering-service";
import { MultiSelect } from "primereact/multiselect";
import PrimeDialog from "../../components/dialog/PrimeDialog";

export default function CompanyBinding_Detail({ backToUrl = "companyBinding" }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { itemObj, setItemObj, action, setAction, currentStatus, setCurrentStatus } = useOutletContext();
  const [detailObj, setDetailObj] = useState({});
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [, loading] = useContext(SystemLoading);
  const [editAction, setEditAction] = useState("detail"); //設定目前的動作
  const [industryList, setIndustryList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [maskView, setMaskView] = useState(false);
  const chsFuncId = useFuncId();
  const isEditable = useEditableFlag('B10201'); // control edit by B10201
  const [localeList, setLocaleList] = useState([]);
  const [state, dispatchUser] = useContext(AcctContext); //使用者資訊
  const [countryList, setCountryList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [tagListModal, setTagListModal] = useState(false);
  const [originalTagList, setOriginalTagList] = useState([]);

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      name: "",
      useTypes: [],
    },
    //錯誤驗證時機
    mode: "all",
  });

  const btnBackTo = () => {
    navigate(`/management/${backToUrl}`);
  };

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  const { fields: tagFields, append: addForm, remove: delForm } = useFieldArray({
    control,
    name: "editTagList",
  });

  const onSubmit = (data) => {
    let reqBody = {
      companySeq: detailObj?.companySeq,
      name: data.name,
      industryCode: data.industryCode,
      address: data.address,
      leader: data.leader,
      email: data.email,
      locale: data.locale,
      country: data.country,
      ...(state?.companyType === "M" && { remark: data.remark }),
      ...(state?.companyType === "M" && { tagList: data.tagList }),
    };
    axios_updateCompaniesInfo(reqBody);
  };

  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    B1020103Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule]
  );

  const axios_updateCompaniesInfo = (reqBody) => {
    updateCompaniesInfo(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
        btnBackTo();
      }
    });
  };

  useEffect(() => {
    if (action !== "") {
      setEditAction(action);
      axios_getCreateBefore();
      axios_queryIndustryList();
      axios_queryLocaleDropdown();
      axios_queryCompaniesInfo();
      axios_getCompanyStatusList();
      axios_queryCBAMSubItemsByItemNo("CBAM_COUNTRIES", 0).then(setCountryList);
      if (state.companyType === "M") {
        axios_queryCompanyTagList();
        axios_B1020107Before();
      }
    } else {
      btnBackTo();
    }
  }, [action]);

  const axios_B1020107Before = () => {
    checkLoading(loading);
    B1020107Before()
      .then((res) => {
        if (checkDpSuccess(res)) {
          setFormRule(processConstraints(res?.data?.RespBody?.constraints));
        }
      })
      .finally(() => {
        checkLoading(loading, false);
      });
  };

  const processConstraints = (constraints) => {
    return constraints.map((item) => {
      if (item?.subObject?.value) {
        return { [item?.field]: processConstraints(item?.subObject.value) };
      } else {
        return addFormValidator(item?.field, constraints);
      }
    });
  };

  const setValidTagListForm = useCallback(
    (formId) => {
      if (setValidForm("tagList")?.length > 0) {
        const tmp = setValidForm("tagList")?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [setValidForm("tagList")]
  );

  const axios_queryCompaniesInfo = () => {
    checkLoading(loading);
    queryCompaniesInfo({ companySeq: itemObj?.companySeq })
      .then((res) => {
        let data = res?.data?.RespBody;
        setDetailObj(data);
        setValue("name", data?.name, { shouldValidate: true });
        setValue("industryCode", data?.industryCode, { shouldValidate: true });
        setValue("status", data?.status, { shouldValidate: true });
        setValue("leader", data?.leader, { shouldValidate: true });
        setValue("email", data?.email, { shouldValidate: true });
        setValue("address", data?.address, { shouldValidate: true });
        setValue("locale", data?.locale);
        setValue("useS3Bucket", data?.useS3Bucket);
        setValue("s3BucketQuota", data?.s3BucketQuota);
        setValue("remark", data?.remark);
        setValue("country", data?.country);
        setValue("tagList", data?.tagList);
        clearErrors();
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  //取得行業別下拉清單
  const axios_queryIndustryList = () => {
    queryIndustryList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody?.industryList;
        setIndustryList(data);
      }
    });
  };

  const axios_getCompanyStatusList = () => {
    getSubItemsByItemNo("COMPANY_STATUS", 23).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setStatusList(newArray);
      }
    });
  };

  // 國家下拉選單
  const axios_queryCBAMSubItemsByItemNo = (itemNo, orderNo) => {
    return getCBAMSubItemsByItemNo(itemNo, orderNo).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        return data.map((item, index) => ({
          ...item,
          index,
        }));
      }
      return [];
    });
  };

  const handleMaskClick = () => {
    setMaskView((prev) => {
      return !prev;
    });
  };

  const axios_updateAuditEyesEvent = () => {
    updateAuditEyesEvent({
      functionId: chsFuncId,
      eventType: "E",
    }).then((res) => {
      if (checkDpSuccess(res)) {
      }
    });
  };

  const axios_queryLocaleDropdown = () => {
    queryLocaleList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody?.localeList;
        setLocaleList(data);
      }
    });
  };

  const axios_queryCompanyTagList = () => {
    queryCompanyTagList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody?.tagList;
        setTagList(data);
        setValue("editTagList", data);
      }
    });
  };

  const axios_updateCompanyTagList = () => {
    updateCompanyTagList({
      tagList: getValues("editTagList"),
    }).then((res) => {
      if (checkDpSuccess(res)) {
        handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
        axios_queryCompanyTagList();
        axios_queryCompaniesInfo();
      }
    });
  };

  const handleResetForm = (index) => {
    delForm(index);
    addForm({ companiesTagSeq: "" });
    clearErrors();
  };

  const handleDelForm = (index, length) => {
    if (length > 1) {
      delForm(index);
    } else {
      delForm(index);
      addForm({ companiesTagSeq: "" });
    }
  };

  return (
    <>
      {/* 返回上頁 */}
      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button
            rounded
            text
            onClick={() => {
              btnBackTo();
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t("button.return_to_list")}
          </Button>
        </div>
      </div>
      <div className="p-card">
        <div className="p-card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid">
              {/*統一編號*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("company_num")}</label>
                <span>{detailObj?.taxIdNum}</span>
              </div>
              {/*組織名稱*/}
              <div className="col-12 lg:col-3">
                <FormInput
                  register={register}
                  errors={errors}
                  id="name"
                  type="text"
                  labelClass={`control-label ${editAction === "update" ? "required" : ""}`}
                  enterClick={checkKeyDown}
                  labelText={t("org_name")}
                  disabled={editAction === "detail"}
                  rules={setValidForm("name")}
                />
              </div>
              {/* 行業代碼 */}
              <div className="col-12 lg:col-3">
                <label htmlFor="industryCode" className={`form-label ${editAction === "update" ? "required" : ""}`}>
                  {t("industry")}
                </label>
                <Controller
                  name="industryCode"
                  control={control}
                  rules={setValidForm("industryCode")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={editAction === "detail"}
                      filter
                      optionLabel="industryName"
                      optionValue="industryCode"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="industryCode"
                      control={control}
                      options={industryList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "industryCode")}
              </div>
              {/* 狀態 */}
              <div className="col-12 lg:col-3">
                <label htmlFor="status" className="form-label">
                  {t("status")}
                </label>
                <Controller
                  name="status"
                  control={control}
                  // rules={setValidForm('industryCode')}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={true}
                      filter
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="status"
                      control={control}
                      options={statusList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "status")}
              </div>
            </div>
            <div className="grid my-1">
              {/*負責人*/}
              <div className="col-12 lg:col-3">
                {/* <FormInput
                        register={register}
                        errors={errors}
                        id="leader"
                        type="text"
                        labelClass={`control-label ${editAction==='update'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('companyLeader')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("leader")}
                    /> */}
                <Controller
                  name="leader"
                  control={control}
                  rules={setValidForm("leader")}
                  render={({ field, fieldState }) => (
                    <MaskedFormInput
                      {...field}
                      type="text"
                      labelClass={`control-label ${editAction === "update" ? "required" : ""}`}
                      labelText={t("companyLeader")}
                      maskType="username"
                      maskView={maskView}
                      setMaskView={() => handleMaskClick()}
                      disabled={editAction === "detail"}
                      errorMessage={fieldState.error?.message}
                      onKeyDown={checkKeyDown}
                    />
                  )}
                />
              </div>
              {/*電子信箱*/}
              <div className="col-12 lg:col-3">
                {/* <FormInput
                        register={register}
                        errors={errors}
                        id="email"
                        type="text"
                        labelClass={`control-label ${editAction==='update'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('companyEamil')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("email")}
                    /> */}
                <Controller
                  name="email"
                  control={control}
                  rules={setValidForm("email")}
                  render={({ field, fieldState }) => (
                    <MaskedFormInput
                      {...field}
                      type="email"
                      labelClass={`control-label ${editAction === "update" ? "required" : ""}`}
                      labelText={t("companyEamil")}
                      maskType="email"
                      maskView={maskView}
                      setMaskView={() => handleMaskClick()}
                      disabled={editAction === "detail"}
                      errorMessage={fieldState.error?.message}
                      onKeyDown={checkKeyDown}
                    />
                  )}
                />
              </div>
              {/*地址*/}
              <div className="col-12 lg:col-6">
                {/* <FormInput
                        register={register}
                        errors={errors}
                        id="address"
                        type="text"
                        labelClass="control-label"
                        enterClick={checkKeyDown}
                        labelText={t('address')}
                        disabled={editAction==='detail'}   
                        rules={setValidForm("address")}                     
                    /> */}
                <Controller
                  name="address"
                  control={control}
                  rules={setValidForm("address")}
                  render={({ field, fieldState }) => (
                    <MaskedFormInput
                      {...field}
                      type="text"
                      labelClass="control-label"
                      labelText={t("address")}
                      maskType="address"
                      maskView={maskView}
                      setMaskView={() => handleMaskClick()}
                      disabled={editAction === "detail"}
                      errorMessage={fieldState.error?.message}
                      onKeyDown={checkKeyDown}
                    />
                  )}
                />
              </div>
            </div>
            <div className="grid my-1">
              {/*類型*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("type")}</label>
                <span>{detailObj?.typeName}</span>
              </div>
              {/*授權類型*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("authorizationType")}</label>
                <span>{detailObj?.effectiveTypeName}</span>
              </div>
              {/*會員等級*/}
              <div className="col-12 lg:col-3">
                <label htmlFor="companyLevel" className="form-label">
                  {t("membershipLevel")}
                </label>
                <span>{detailObj?.companyLevelName}</span>
              </div>
              {/*授權起訖日*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("authorizationDate")}</label>
                <span>
                  {detailObj?.effectiveStartDate} ~ {detailObj?.effectiveEndDate}
                </span>
              </div>
            </div>
            <div className="grid">
              {/* 國家 */}
              <div className="col-12 lg:col-3">
                <label className={`form-label ${editAction === "update" ? "required" : ""}`}>{t("country")}</label>
                <Controller
                  name="country"
                  control={control}
                  rules={setValidForm("country")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      filter
                      disabled={editAction === "detail"}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      defaultValue={""}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      placeholder={t("plz_chs")}
                      options={countryList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "country")}
              </div>
              {/*使用語言*/}
              <div className="col-12 lg:col-3">
                <label htmlFor="locale" className={`form-label ${editAction === "update" ? "required" : ""}`}>
                  {t("useLanguage")}
                </label>
                <Controller
                  name="locale"
                  control={control}
                  rules={setValidForm("locale")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={editAction === "detail"}
                      optionLabel="localeName"
                      optionValue="locale"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      options={localeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "locale")}
              </div>
              {/*檔案上傳容量上限(GB)*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("s3BucketQuota")}</label>
                <span>{detailObj?.s3BucketQuota}</span>
              </div>
              {/*碳足跡可用件數*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("cfpReportQuota")}</label>
                <span>{detailObj?.cfpReportQuota}</span>
              </div>
              {/*可建立場所數*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("placeCreateCount")}</label>
                <span>{detailObj?.placesQuota}</span>
              </div>
              {/*可建立盤查計劃數*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("planCreateCount")}</label>
                <span>{detailObj?.cfvPlanQuota}</span>
              </div>
              {/*可建立帳戶數*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("accountCreateCount")}</label>
                <span>{detailObj?.userQuota}</span>
              </div>
              {/*可建立CBAM數*/}
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("cbamCreateCount")}</label>
                <span>{detailObj?.cbamQuota}</span>
              </div>
            </div>

            <div className="grid">
              {/* Tag */}
              <div className="col-6">
                {state.companyType === "M" && (
                  <>
                    <label htmlFor="tagList" className="form-label">
                      {t("tag")}
                      <Button
                        type="button"
                        size="small"
                        text
                        severity="secondary"
                        icon="pi pi-cog"
                        label={`${t("button.edit")}${t("tag")}`}
                        onClick={() => {
                          setOriginalTagList(tagFields);
                          setTagListModal(true);
                        }}
                        style={{ margin: "0px 1rem", padding: "0px" }}
                      />
                    </label>
                    <Controller
                      name="tagList"
                      control={control}
                      render={({ field }) => (
                        <MultiSelect
                          filter
                          showClear
                          disabled={editAction === "detail"}
                          className="w-full"
                          style={{ width: "100%" }}
                          display="chip"
                          options={tagList}
                          optionLabel={"tagName"}
                          optionValue={"companiesTagSeq"}
                          value={field.value}
                          onChange={(e) => {
                            field.onChange(e.value);
                          }}
                        ></MultiSelect>
                      )}
                    />
                  </>
                )}
              </div>
              {/*備註*/}
              <div className="col-12">
                {state.companyType === "M" && (
                  <div className="grid">
                    <div className="col-12">
                      <FormTextarea
                        register={register}
                        errors={errors}
                        id="remark"
                        name="remark"
                        type="text"
                        labelText={t("remark")}
                        areaClass="w-full"
                        disabled={editAction === "detail"}
                        rules={setValidForm("technicalDescription")}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="grid">
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("create_user")}</label>
                <span>{detailObj?.createUser}</span>
              </div>
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("create_date")}</label>
                <span>{detailObj?.createDateTime}</span>
              </div>
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("update_user")}</label>
                <span>{detailObj?.updateUser}</span>
              </div>
              <div className="col-12 lg:col-3">
                <label className="form-label">{t("update_date")}</label>
                <span>{detailObj?.updateDateTime}</span>
              </div>
            </div>

            <div className="col-12 gap-2 flex-all-center">
              {editAction === "detail" ? (
                <div className="col-12 gap-2 flex-all-center">
                  <Button
                    disabled={!isEditable}
                    label={t("button.edit")}
                    onClick={(e) => {
                      e.preventDefault();
                      setEditAction("update");
                      setMaskView(true);
                      axios_updateAuditEyesEvent();
                    }}
                    type="button"
                    size="small"
                  />
                </div>
              ) : (
                <>
                  <Button disabled={!isValid} type="submit" label={t("button.confirm")} size="small" />
                  <Button
                    outlined
                    size="small"
                    type="button"
                    label={t("button.cancel")}
                    onClick={(e) => {
                      setMaskView(false);
                      btnBackTo();
                    }}
                  />
                </>
              )}
            </div>
          </form>
        </div>
      </div>

      <PrimeDialog
        visible={tagListModal}
        size="lg"
        disabledConfirm={false}
        onClose={() => {
          const currentValues = getValues();
          reset({
            ...currentValues,
            editTagList: originalTagList,
          });
          setTagListModal(false);
        }}
        onConfirm={() => {
          axios_updateCompanyTagList();
          setTagListModal(false);
        }}
        title={t("button.update")}
        bodyTemplate={
          <>
            {tagFields.map((item, index) => (
              <div key={index} className="grid">
                <div className="col-5">
                  <FormInput
                    register={register}
                    errors={errors}
                    id={`editTagList[${index}].tagName`}
                    name={`editTagList[${index}].tagName`}
                    labelText={t("productName")}
                    labelClass="required"
                    rules={setValidTagListForm(`tagName`)}
                  />
                </div>
                <div className="col-6">
                  <FormTextarea
                    register={register}
                    errors={errors}
                    id={`editTagList[${index}].tagDetail`}
                    name={`editTagList[${index}].tagDetail`}
                    text="text"
                    labelText={t("descript")}
                    labelClass="required"
                    rows={1}
                    rules={setValidTagListForm(`tagDetail`)}
                  />
                </div>
                <div className="col-1">
                  <button
                    type="button"
                    className="icon-btn"
                    onClick={() => {
                      tagFields?.length === 1 ? handleResetForm(index) : handleDelForm(index, tagFields?.length);
                    }}
                  >
                    <i className="pi pi-minus"></i>
                  </button>
                </div>
              </div>
            ))}

            <div className="form-group">
              <button
                type="button"
                className="icon-btn"
                onClick={() => {
                  addForm({ companiesTagSeq: "" });
                }}
              >
                <i className="pi pi-plus"></i>
              </button>
            </div>
          </>
        }
      />
    </>
  );
}
